import { useEffect } from 'react';

// Saat tab kasir/admin/dapur TERBUKA dan sebuah Web Push masuk (pesanan baru), service worker meneruskannya ke halaman:
// bunyikan nada pesanan yang sama dengan aplikasi kasir (notification.mp3). (Saat tab/browser ditutup, suara berasal dari notifikasi sistem.)
export default function useSuaraPushStaf() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return undefined;
    const tangani = (e) => {
      const d = e.data || {};
      if (d.sumber !== 'sw-push' || d.tipe !== 'pesanan_baru') return;
      try {
        const audio = new Audio(`${process.env.PUBLIC_URL || ''}/notif.mp3`);
        audio.volume = 0.9;
        audio.play().catch(() => {});
      } catch (_) { /* autoplay bisa diblokir sampai ada sentuhan pertama */ }
    };
    navigator.serviceWorker.addEventListener('message', tangani);
    return () => navigator.serviceWorker.removeEventListener('message', tangani);
  }, []);
}
